import React, { useState } from "react";
import {
  FormContainer,
  FormHeader,
  FormField,
  SubmitButton,
  Message
} from "./EncerrarGravidezForm.styles";
import api from "../../services/api";
import ConfirmModal from "../Modals/ConfirmModal";

const formatToInputDate = (dateStr) => {
  // Verifica se a data está no formato dd/mm/yyyy
  if (!dateStr || typeof dateStr !== "string") return "";

  const [day, month, year] = dateStr.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

const EncerrarGravidezForm = ({ gravidez, onClose }) => {
  const [formValues, setFormValues] = useState({
    gestante_cpf: gravidez.gestante_cpf || "",
    id: gravidez.id,
    dum: formatToInputDate(gravidez.data),
    data_fim: gravidez.data_fim,
    motivo_encerramento: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");
    setIsConfirmModalOpen(true);
  };

  const handleConfirmEncerramento = async () => {
    setIsSubmitting(true);

    try {
      const response = await api.patch(
        `/gestante/${formValues.gestante_cpf}/gravidez/${formValues.id}/encerrar`,
        { 
          data_fim: formValues.data_fim, 
          motivo_encerramento: formValues.motivo_encerramento,
        }
      );

      if (response.status === 200) {
        setSuccessMessage("Gestação encerrada com sucesso!");
        setTimeout(() => {
          onClose();
        }, 1500);
      } else {
        const errorData = response.data;
        setErrorMessage(errorData.detail || "Erro ao encerrar gestação.");
      }
    } catch (error) {
      const errorDetail = error.response?.data?.detail || "Erro de conexão com o servidor.";
      setErrorMessage(errorDetail);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FormContainer>
      <FormHeader>Encerrar Gestação</FormHeader>
      <form onSubmit={handleSubmit}>
        <FormField>
          <label>CPF da Gestante:</label>
          <input type="text" value={formValues.gestante_cpf} disabled />
        </FormField>

        <FormField>
          <label>Data da Última Menstruação (DUM):</label>
          <input
            type="date"
            name="dum"
            value={formValues.dum}
            disabled
          />
        </FormField>

        <FormField>
          <label>Data de Encerramento da Gestação:</label>
          <input
            type="date"
            name="data_fim"
            value={formValues.data_fim}
            onChange={handleChange}
            required
            min={formValues.dum}
          />
        </FormField>

        <FormField>
          <label>Motivo de Encerramento:</label>
          <select
            name="motivo_encerramento"
            value={formValues.motivo_encerramento}
            onChange={handleChange}
            required
          >
            <option value="">Selecione uma opção</option>
            <option value="Perda Gestacional">Perda Gestacional</option>
            <option value="Nascimento">Nascimento</option>
          </select>
        </FormField>

        <SubmitButton type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Encerrando..." : "Encerrar"}
        </SubmitButton>
      </form>

      {successMessage && <Message>{successMessage}</Message>}
      {errorMessage && <Message isError>{errorMessage}</Message>}

      <ConfirmModal
        isOpen={isConfirmModalOpen}
        onClose={() => setIsConfirmModalOpen(false)}
        onConfirm={handleConfirmEncerramento}
        title="Encerrar Gestação"
        message="A ação de encerrar a gestação é definitiva. Você tem certeza que essa gestação deve ser encerrada?"
        confirmText="Confirmar"
        cancelText="Cancelar"
        confirmButtonColor="#1a1a1a"

      />
    </FormContainer>
  );
};

export default EncerrarGravidezForm;
